import { Module } from "vuex";

export const menu: Module<any, any> = {
  state: {
    index: "",
  },
  getters: {
    index: (state) => state.index,
  },
  mutations: {
    setmenu(state, data) {
      state.index = data;
    },
  },
  actions: {
    setmenu(data) {
      data.commit("setmenu");
    },
  },
};
